export const iconFontAwesomeMediaplaybackForwardStep = (
	<i className="fa-solid fa-forward-step"></i>
);
